import React, { useState } from "react";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import { LOGO_URL } from "@/data/siteContent";
import { api, getApiError } from "@/lib/api";

export default function AdminLogin({ onLogin }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      onLogin(data);
    } catch (requestError) {
      setError(getApiError(requestError));
    }
  };
  return (
    <main className="admin-gate">
      <section className="login-card" data-testid="admin-login-card">
        <a className="login-brand" href="/" data-testid="admin-login-brand-link"><img src={LOGO_URL} alt="Protech Heating & Cooling logo" /><span><strong>Protech</strong><small>Private editor</small></span></a>
        <h1 className="login-title">Control<br />room.</h1>
        <p className="login-copy">{`Sign in to update the public page, manage the image library, and review new requests.`}</p>
        <form onSubmit={submit} data-testid="admin-login-form">
          <div className="form-field"><label className="form-label" htmlFor="admin-email">Email</label><input className="text-input" id="admin-email" type="email" value={form.email} onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))} placeholder="admin@example.com" required data-testid="admin-email-input" /></div>
          <div className="form-field"><label className="form-label" htmlFor="admin-password">Password</label><input className="text-input" id="admin-password" type="password" value={form.password} onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))} required data-testid="admin-password-input" /></div>
          {error && <p className="form-error" data-testid="admin-login-error">{error}</p>}
          <button className="button login-submit" type="submit" data-testid="admin-login-submit-btn"><LockKeyhole /> Open editor</button>
        </form>
        <a className="login-back" href="/" data-testid="admin-back-home-link"><ArrowLeft size={14} /> Back to public page</a>
      </section>
    </main>
  );
}
